/**
 * Built-in language packs (packs/*.json). They ship with the apps and the platform API and go
 * through the same validation as runtime packs. English is the reference pack.
 */
import dePack from '../packs/de.json' with { type: 'json' };
import enPack from '../packs/en.json' with { type: 'json' };
import { flattenMessages, validatePack, type FlatMessages, type ValidatedPack } from './pack.js';

/** The locale whose pack defines the key schema and fills every gap. */
export const REFERENCE_LOCALE = 'en';

/** Flat English messages: the key schema. */
export const referenceMessages: FlatMessages = flattenMessages(enPack.messages);

const raw: Readonly<Record<string, unknown>> = { en: enPack, de: dePack };

/** Built-in packs by locale, validated against English. */
export const BUILTIN_PACKS: Readonly<Record<string, ValidatedPack>> = Object.fromEntries(
  Object.entries(raw).map(([locale, pack]) => [locale, validatePack(pack, { reference: referenceMessages, expectedLocale: locale })]),
);

/** Locales built into every app. */
export const BUILTIN_LOCALES: readonly string[] = Object.keys(raw);

/** The English pack as shipped (nested), for the type of the key schema. */
export type ReferencePack = typeof enPack;
